import Textbook from './Textbook';

export default Textbook;